// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#show-toggler[data-v-2ba25dd3]{display:block!important;padding:1.5rem 0 1.5rem 1.5rem}", ""]);
// Exports
module.exports = exports;
